document.addEventListener('DOMContentLoaded', function () {
  showSelectedVariant();
});

/**
 * getVariantIndex
 *  @returns {Number}
 */
export function getVariantIndex() {
  var _variantImage$dataset;
  var paramString = window.location.search;
  if (!paramString) return 0;
  var urlParams = new URLSearchParams(paramString);
  var variant = urlParams.get('variant');
  if (!variant) return 0;

  /** @type {HTMLElement | null} */
  var variantImage = document.querySelector(".product__media [data-variant-ids*=\"".concat(variant, "\"]"));
  return (variantImage === null || variantImage === void 0 || (_variantImage$dataset = variantImage.dataset) === null || _variantImage$dataset === void 0 ? void 0 : _variantImage$dataset.index) || 0;
}

/**
 * Navigate to variant image
 * @param {String | null | undefined} [variantId] - fired in variant-selector.js
 */
export function showSelectedVariant() {
  var variantId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  // Get from URL
  if (!variantId) {
    var paramString = window.location.search;
    if (paramString) {
      var urlParams = new URLSearchParams(paramString);
      variantId = urlParams.get('variant') || undefined;
    }
  }

  // Fall back to initial variant
  if (!variantId) {
    var productWrapper = document.querySelector('.product__wrapper[data-initial-variant]');
    if (productWrapper instanceof HTMLElement) {
      variantId = productWrapper.dataset.initialVariant;
    }
  }
  if (!variantId) return;
  var isTieredLayout = document.querySelector('.product__media .vertical-scroll-tiered') !== undefined;

  /** @type {NodeListOf<HTMLElement>} */
  var pdpMediaItems = document.querySelectorAll('.product__media .carousel-wrapper [data-pdp-media-item]');

  /** @type {NodeListOf<HTMLElement>} */
  var variantItems = document.querySelectorAll(".product__media .carousel-wrapper [data-variant-id=\"".concat(variantId, "\"]"));
  if (variantItems) {
    pdpMediaItems.forEach(function (item) {
      item.style.order = '';
      item.classList.remove('col-span-2');
    });
    variantItems.forEach(function (item, index) {
      if (index === 0 && isTieredLayout) {
        item.classList.add('col-span-2');
      }
      item.style.order = -999 + index;
    });
  }
}